import { useState } from 'react';

interface NewsItem {
  id: number;
  date: string;
  year: number;
  title: string;
  url?: string;
}

const newsData: NewsItem[] = [
  {
    id: 20301,
    date: '2026.03.01',
    year: 2026,
    title: 'StarLight PolaRis THE BEST 2021-2025 個別握手会 & 個別CDジャケットサイン会 ヘアメイクを担当させていただきました。',
    url: 'https://starlight-polaris-the-best.starpola.com/',
  },
  {
    id: 20228,
    date: '2026.02.28',
    year: 2026,
    title: 'StarLight PolaRis THE BEST 2021-2025 個別握手会 & 個別CDジャケットサイン会 ヘアメイクを担当させていただきました。',
    url: 'https://starlight-polaris-the-best.starpola.com/',
  },
  {
    id: 20226,
    date: '2026.02.26',
    year: 2026,
    title: '放送40回突破記念！Mr.生JACK！が斬る！ JiMYY（MAMA.）様 / 諒平（Azavana）様 ヘアメイクを担当させていただきました。',
    url: 'https://www.youtube.com/live/1WXE8519_SY?si=nKeqCqEPHinJ4ImG',
  },
  {
    id: 20223,
    date: '2026.02.23',
    year: 2026,
    title: 'StarLight PolaRis 個別お渡し会 ヘアメイクを担当させていただきました。',
    url: 'https://starlight-polaris-the-best.starpola.com/',
  },
  {
    id: 20222,
    date: '2026.02.22',
    year: 2026,
    title: '-hotoke- 2ndワンマンライブ ゲスト様ヘアメイクを担当（hairmake ENCHANT）',
    url: 'https://ireisu.com/live/38',
  },
  {
    id: 20221,
    date: '2026.02.22',
    year: 2026,
    title: 'If 2ndワンマンライブ -READY TO BLOOM- ヘアメイクを担当させていただきました。',
    url: 'https://ireisu.com/live/37',
  },
  {
    id: 20208,
    date: '2026.02.08',
    year: 2026,
    title: 'StarLight PolaRis THE BEST 2021-2025 個別握手会 & 個別CDジャケットサイン会 ヘアメイクを担当させていただきました。',
    url: 'https://starlight-polaris-the-best.starpola.com/',
  },
  {
    id: 20207,
    date: '2026.02.07',
    year: 2026,
    title: 'StarLight PolaRis THE BEST 2021-2025 個別握手会 & 個別CDジャケットサイン会 ヘアメイクを担当させていただきました。',
    url: 'https://starlight-polaris-the-best.starpola.com/',
  },
  {
    id: 10131,
    date: '2026.01.31',
    year: 2026,
    title: 'StarLight PolaRis One Man Live in パシフィコ横浜（Sirius / Orion） ヘアメイクを担当させていただきました。',
    url: 'https://starpola.com/news/810',
  },
  {
    id: 10125,
    date: '2026.01.25',
    year: 2026,
    title: '初兎 2ndワンマンライブ -LAST EDEN-（豊洲PIT） ヘアメイクを担当させていただきました。',
    url: 'https://ireisu.com/live/35',
  },
  {
    id: 10124,
    date: '2026.01.25',
    year: 2026,
    title: '悠佑 2ndワンマンライブ -獅子咆天-（豊洲PIT）悠佑様・ゲスト様ヘアメイクを担当（hairmake ENCHANT）',
    url: 'https://ireisu.com/live/36',
  },
  {
    id: 10220,
    date: '2025.12.20',
    year: 2025,
    title: 'りうら 2ndワンマンライブ -Burning Flair-（豊洲PIT）ゲスト様ヘアメイクを担当（hairmake ENCHANT）',
    url: 'https://ireisu.com/live/34',
  },
  {
    id: 10219,
    date: '2025.12.20',
    year: 2025,
    title: 'ないこ 2ndワンマンライブ -ないふぁみ3,000者面談-（豊洲PIT） ヘアメイクを担当させていただきました。',
    url: 'https://ireisu.com/live/33',
  },
  {
    id: 10218,
    date: '2025.12.18',
    year: 2025,
    title: 'MAMA. お正月衣装 ヘアメイクを担当させていただきました。',
    url: 'https://x.com/MAMA_st_MORRY/status/2001608487047135352?s=20',
  },
  {
    id: 10212,
    date: '2025.12.12',
    year: 2025,
    title: 'MAMA. ONEMAN TOUR CRY MORRY 新潟 CLUB RIVERST ヘアメイクを担当させていただきました。',
    url: 'https://x.com/_MAMA_OFFICIAL/status/1999445104038412558?s=20',
  },
  {
    id: 10128,
    date: '2025.11.28',
    year: 2025,
    title: 'MAMA. ONEMAN TOUR CRY MORRY 横浜 7th AVENUE ヘアメイクを担当させていただきました。',
    url: 'https://x.com/_MAMA_OFFICIAL/status/1994371626729967829?s=20',
  },
  {
    id: 10110,
    date: '2025.11.10',
    year: 2025,
    title: 'MAMA. × CHAQLA. × nurié presents. 『漢上げ』~また、必ず~ MAMA.様ヘアメイクを担当（hairmake ENCHANT）',
  },
  {
    id: 10113,
    date: '2025.10.13',
    year: 2025,
    title: 'MAMA. 関連コンテンツ ヘアメイクを担当させていただきました。',
    url: 'https://x.com/_MAMA_OFFICIAL/status/1977692124901716048?s=20',
  },
  {
    id: 10106,
    date: '2025.10.06',
    year: 2025,
    title: 'DANCER HARUNA ヘアメイクを担当させていただきました。',
    url: 'https://www.instagram.com/p/DPdy5W1Ehfs/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==',
  },
  {
    id: 10104,
    date: '2025.10.04',
    year: 2025,
    title: 'MAMA.『やってみよう vol.2』 ヘアメイクを担当させていただきました。',
    url: 'https://x.com/Like_an_Edison/status/1974456723071971605?s=20',
  },
  {
    id: 9930,
    date: '2025.09.30',
    year: 2025,
    title: 'Miiink WEAR look ヘアメイクを担当させていただきました。',
    url: 'https://www.instagram.com/miiinkstore?igsh=MXcwaXRubzY3djh0Ng==',
  },
  {
    id: 9927,
    date: '2025.09.27',
    year: 2025,
    title: 'いれいす Summer Tour 2025「えびばでぃ - 祭 - FESTIVAL !!」Kアリーナ横浜公演（2DAYS） ヘアメイクを担当させていただきました。',
    url: 'https://ireisu.com/news/730',
  },
  {
    id: 9906,
    date: '2025.09.06',
    year: 2025,
    title: 'いれいす 7th Full Album「放課後アーカイブ」発売記念「推しが選べるリアルハイタッチ会」 ヘアメイクを担当させていただきました。',
    url: 'https://ireisu.com/news/779',
  },
  {
    id: 8007,
    date: '2025.08.31',
    year: 2025,
    title: 'すたぽら 2nd Single「おぎゃりたい！えぶりでい」発売記念握手会 ヘアメイクを担当させていただきました。',
    url: 'https://wanna-be-baby.starpola.com/',
  },
  {
    id: 8006,
    date: '2025.08.23',
    year: 2025,
    title: 'いれいす Summer Tour 2025「えびばでぃ - 祭 - FESTIVAL !!」Aichi Sky Expo公演（2DAYS） ヘアメイクを担当させていただきました。',
    url: 'https://ireisu.com/news/730',
  },
  {
    id: 8005,
    date: '2025.08.16',
    year: 2025,
    title: 'miiink ARTBOOK ヘアメイクを担当させていただきました。',
    url: 'https://www.instagram.com/p/DOPkkydCSmB/?igsh=bTV5YThtN3pwYWJn',
  },
  {
    id: 8004,
    date: '2025.08.16',
    year: 2025,
    title: 'いれいす Summer Tour 2025「えびばでぃ - 祭 - FESTIVAL !!」GLION ARENA KOBE公演（2DAYS） ヘアメイクを担当させていただきました。',
    url: 'https://ireisu.com/news/730',
  },
  {
    id: 8003,
    date: '2025.08.09',
    year: 2025,
    title: 'いれいす Summer Tour 2025「えびばでぃ - 祭 - FESTIVAL !!」マリンメッセ福岡（2DAYS） ヘアメイクを担当させていただきました。',
    url: 'https://ireisu.com/news/730',
  },
  {
    id: 8002,
    date: '2025.08.06',
    year: 2025,
    title: '【実写MV】Mrs. GREEN APPLE - 僕のこと ／全部俺の声 ヘアメイクを担当させていただきました。',
    url: 'https://youtu.be/ilxe3WiJsu4?si=eM7fQktb0R-zx2lQ',
  },
  {
    id: 8001,
    date: '2025.08.02',
    year: 2025,
    title: 'いれいす Summer Tour 2025「えびばでぃ - 祭 - FESTIVAL !!」ゼビオアリーナ仙台公演（2DAYS） ヘアメイクを担当させていただきました。',
    url: 'https://ireisu.com/news/730',
  },
  {
    id: 7001,
    date: '2025.07.13',
    year: 2025,
    title: '【MV】ぜったいてきしんじゃ！ / いれいす ヘアメイクを担当させていただきました。',
    url: 'https://youtu.be/r6hYacD3PkM?si=yl9MWNQza-IqC4si&t=172',
  },
  {
    id: 7002,
    date: '2025.07.07',
    year: 2025,
    title: 'MAMA.「やってみよう vol.1」 ヘアメイクを担当させていただきました。',
    url: 'https://x.com/Like_an_Edison/status/1964697770335539407?s=20',
  },
  {
    id: 7003,
    date: '2025.06.30',
    year: 2025,
    title: 'plusTALK様 新作ルック ヘアメイクを担当させていただきました。',
    url: 'https://plustalk.online/',
  },
  {
    id: 1,
    date: '2025.06.20',
    year: 2025,
    title: '【特別先行公開】捕まったら即お仕置き…極限の「罰ゲーム鬼ごっこ~Revenge~」開幕！【ライブティザーPV】 ヘアメイクを担当させていただきました。',
    url: 'https://youtu.be/gmbf4EfQ32Y?si=ZCBjHcoq-JoMTZd4',
  },
  {
    id: 2,
    date: '2025.06.08',
    year: 2025,
    title: 'いれいすファンクラブイベント ~ Irregular Party!! ~ Vol.1 ヘアメイクを担当させていただきました。',
    url: 'https://ireisu.com/news/731',
  },
];

// 8件目以降を年でグループ化
const recentItems = newsData.slice(0, 8);
const olderItems = newsData.slice(8);

const groupByYear = (items: NewsItem[]) => {
  return items.reduce<Record<number, NewsItem[]>>((acc, item) => {
    if (!acc[item.year]) acc[item.year] = [];
    acc[item.year].push(item);
    return acc;
  }, {});
};

function NewsRow({ item }: { item: NewsItem }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-6 py-4 group transition-all duration-300 hover:pl-3">
      <span className="text-xs text-gray-500 tracking-wider whitespace-nowrap font-mono shrink-0 pt-0.5">
        {item.date}
      </span>
      <div className="flex flex-col gap-1">
        <p className="text-sm text-gray-300 group-hover:text-white transition-colors duration-300 leading-relaxed whitespace-pre-line select-none">
          {item.title}
        </p>
        {item.url && (
          <a
            href={item.url}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="text-xs text-gray-500 hover:text-gray-300 transition-colors duration-300 break-all cursor-pointer"
          >
            {item.url}
          </a>
        )}
      </div>
    </div>
  );
}

export default function News() {
  const [expanded, setExpanded] = useState(false);
  const [openYears, setOpenYears] = useState<Record<number, boolean>>({});

  const toggleYear = (year: number) => {
    setOpenYears((prev) => ({ ...prev, [year]: !prev[year] }));
  };

  const olderGrouped = groupByYear(olderItems);
  const sortedYears = Object.keys(olderGrouped)
    .map(Number)
    .sort((a, b) => b - a);

  const displayedRecent = expanded ? recentItems : recentItems.slice(0, 2);

  return (
    <section id="news" className="py-24 bg-black">
      <div className="max-w-4xl mx-auto px-6">
        {/* Header */}
        <div className="mb-14 text-center">
          <p className="text-xs tracking-[0.3em] text-gray-500 uppercase mb-3">Latest Updates</p>
          <h2 className="text-3xl md:text-4xl font-bold tracking-widest text-white">NEWS</h2>
          <div className="mt-4 w-12 h-px bg-purple-500 mx-auto"></div>
        </div>

        {/* Recent News List */}
        <div className="divide-y divide-gray-800">
          {displayedRecent.map((item) => (
            <NewsRow key={item.id} item={item} />
          ))}
        </div>

        {/* MORE / LESS button */}
        {!expanded ? (
          <div className="mt-8 text-center">
            <button
              onClick={() => setExpanded(true)}
              className="px-8 py-3 border border-gray-600 text-gray-400 text-xs tracking-widest rounded-full hover:border-white hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              MORE
            </button>
          </div>
        ) : (
          <>
            {/* Older items grouped by year */}
            {olderItems.length > 0 && (
              <div className="mt-8 space-y-3">
                {sortedYears.map((year) => (
                  <div key={year} className="border border-gray-800 rounded-lg overflow-hidden">
                    {/* Year header */}
                    <button
                      onClick={() => toggleYear(year)}
                      className="w-full flex items-center justify-between px-6 py-4 text-left hover:bg-gray-900/60 transition-colors duration-300 cursor-pointer"
                    >
                      <span className="text-sm font-medium tracking-widest text-gray-400">
                        {year}
                      </span>
                      <div className="flex items-center gap-3">
                        <span className="text-xs text-gray-600 tracking-wider">
                          {olderGrouped[year].length}件
                        </span>
                        <div className="w-5 h-5 flex items-center justify-center">
                          <i
                            className={`ri-arrow-down-s-line text-gray-500 transition-transform duration-300 ${
                              openYears[year] ? 'rotate-180' : ''
                            }`}
                          ></i>
                        </div>
                      </div>
                    </button>

                    {/* Year items */}
                    {openYears[year] && (
                      <div className="px-6 divide-y divide-gray-800/60 border-t border-gray-800">
                        {olderGrouped[year].map((item) => (
                          <NewsRow key={item.id} item={item} />
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}

            <div className="mt-8 text-center">
              <button
                onClick={() => setExpanded(false)}
                className="px-8 py-3 border border-gray-700 text-gray-600 text-xs tracking-widest rounded-full hover:border-gray-500 hover:text-gray-400 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                CLOSE
              </button>
            </div>
          </>
        )}
      </div>
    </section>
  );
}
